import React from 'react';
import { Users, Sparkles, Shield } from 'lucide-react';
export const HumAInSection = () => {
  return <section className="w-full py-20 bg-white border-b border-gray-200" data-id="element-203">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-204">
        {/* Main Content */}
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-205">
          <div className="inline-block mb-6" data-id="element-206">
            <h2 className="text-5xl font-bold text-gray-900" data-id="element-207">
              HumAIn<sup className="text-2xl" data-id="element-208">™</sup> Approach
            </h2>
          </div>

          <p className="text-3xl font-medium text-gray-900 mb-6 leading-tight" data-id="element-209">
            AI that assists. Humans who lead.
          </p>

          <div className="w-24 h-1 bg-indigo-600 mx-auto mb-8" data-id="element-210"></div>

          <p className="text-xl text-gray-700 leading-relaxed mb-8" data-id="element-211">
            We believe the future of technology is not AI replacing humans, nor
            humans supervising machines—but{' '}
            <span className="font-semibold text-gray-900" data-id="element-212">
              humans leading with AI as a trusted assistant
            </span>
            .
          </p>

          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-213">
            HumAIn™ is Tudo's (EnterpriseAI) human-first approach to AI
            adoption, designed to enhance speed, quality, and insight without
            compromising judgment, accountability, or trust.
          </p>
        </div>

        {/* Three Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-214">
          <div className="text-center" data-id="element-215">
            <div className="w-16 h-16 bg-gray-900 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg" data-id="element-216">
              <Users className="text-white" size={32} data-id="element-217" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-218">
              Humans Lead
            </h3>
            <p className="text-gray-700" data-id="element-219">
              Decision-making authority and accountability remain with people,
              not algorithms.
            </p>
          </div>

          <div className="text-center" data-id="element-220">
            <div className="w-16 h-16 bg-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg" data-id="element-221">
              <Sparkles className="text-white" size={32} data-id="element-222" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-223">
              AI Assists
            </h3>
            <p className="text-gray-700" data-id="element-224">
              Technology amplifies human capability, providing speed and insight
              at scale.
            </p>
          </div>

          <div className="text-center" data-id="element-225">
            <div className="w-16 h-16 bg-gray-900 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg" data-id="element-226">
              <Shield className="text-white" size={32} data-id="element-227" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-228">
              Trust Preserved
            </h3>
            <p className="text-gray-700" data-id="element-229">
              Judgment, accountability, and ethical oversight remain
              fundamentally human.
            </p>
          </div>
        </div>
      </div>
    </section>;
};